import { Customization, css } from '@eduvision/toolkit';
// import { default as CustomLoggedOutView } from '../views/LoggedOutView';

export const LearningGoals: Customization['LearningGoals'] = {
  maxColumns:1
};
